/**
 * Intercom doesn't provide an official TypeScript SDK.
 * Instead, they provide a JavaScript snippet to inject a script into the app.
 * The only variable the script needs is the app ID.
 * More context: https://developers.intercom.com/installing-intercom/web/installation/#single-page-app.
 */

/* eslint-disable */

import { env } from "../../env"

/**
 * Do not modify this function.
 * It has been copy pasted from Intercom docs.
 */
;(function () {
  const w = window
  const ic = w.Intercom
  if (typeof ic === "function") {
    ic("reattach_activator")
    ic("update", w.intercomSettings)
  } else {
    const d = document
    const i = function () {
      i.c(arguments)
    }
    i.q = []
    i.c = function (args) {
      i.q.push(args)
    }
    w.Intercom = i
    const l = function () {
      const s = d.createElement("script")
      s.type = "text/javascript"
      s.async = true
      s.src = "https://widget.intercom.io/widget/" + env.INTERCOM_APP_ID
      const x = d.getElementsByTagName("script")[0]
      x.parentNode.insertBefore(s, x)
    }
    if (document.readyState === "complete") {
      l()
    } else if (w.attachEvent) {
      w.attachEvent("onload", l)
    } else {
      w.addEventListener("load", l, false)
    }
  }
})()
